/**
 * Vid Modal
 */
export default {

    openCtrl: document.querySelectorAll( '[data-js-vid-open]' ),
    closeCtrl:  document.querySelectorAll( '[data-js-vid-close]' ),

    /**
     * Init
     */
    init: function() {

        if( this.openCtrl.length && this.closeCtrl.length ) {

            for( let i = 0; i < this.openCtrl.length; i++ ) {

                this.openCtrl[i].addEventListener( 'click', event => {

                    event.preventDefault();
                    this.openModal( event );

                } );

            }

            for( let i = 0; i < this.closeCtrl.length; i++ ) {
            
                this.closeCtrl[i].addEventListener( 'click', event => {

                    event.preventDefault();
                    this.closeModal();

                } );

            }

        }

    },

    /**
     * Open
     */
    openModal: function( event ) {
        
        const $target = event.target;

        if( $target.hasAttribute( 'data-js-vid-close' ) ) {

            return;
        }

        if( 
        $target.classList.contains( 'inner' ) ||
        $target.classList.contains( 'is-active' ) ||
        $target.hasAttribute( 'js-gallery-nav' )
        ) {
            this.closeModal();
            return;
        }


        // Find id and element of modal being opened
        const modal_id = $target.getAttribute( 'data-js-vid-open' );
        const $modal = document.querySelector( '[data-js-vid-modal="' + modal_id + '"]' );

        // Add active class
        $modal.classList.add( 'is-active' );

        // Autoplay... 
        const $target_frame = $modal.querySelector( 'iframe' );
        const src = $target_frame.getAttribute( 'src' );
        const query = ( src.includes( 'vimeo' ) ? '?' : '&' );
        const autoplay_src = src + query + 'autoplay=1';

        $target_frame.setAttribute( 'src', autoplay_src );



    },

    /**
     * Close
     */
    closeModal: function() {

        const $modal = document.querySelector( '[data-js-vid-modal].is-active' );

        if( ! $modal ) {
            return;
        }

        // Remove active class of the active modal
        $modal.classList.remove( 'is-active' );

        // Remove autoplay and reset
        const $target_frame = $modal.querySelector( 'iframe' );
        const src = $target_frame.getAttribute( 'src' );
        const query = ( src.includes( 'vimeo' ) ? '?' : '&' );
        const reset_src = src.replace( query + 'autoplay=1' );
        const $frame_container = $target_frame.parentNode;

        $target_frame.setAttribute( 'src', reset_src );
        $frame_container.removeChild( $target_frame );
        $frame_container.appendChild( $target_frame );



    },

 };


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/media/vid-modal.js